import _axios from "../api";

export const getAlarmsNotifications = async (webUserId, maxPassedItems, maxUpcomingItems) => {
  return await _axios
    .get(`/dashboard/action-items/${webUserId}/${maxPassedItems}/${maxUpcomingItems}`)
    .then((response) => {
      return response.data;
    });
};

export const deleteAlarmNotification = async (actionItemDetailId) =>
  await _axios.post(`/dashboard/remove-actionitem/${actionItemDetailId}`).then((response) => {
    return response.data;
  });
